import { render } from "./FrameTable.vue?vue&type=template&id=0966c737"
import script from "./FrameTable.vue?vue&type=script&lang=js"
export * from "./FrameTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__